import Http from "./http";

export const createMaterialAPI = (payload, options) => {
  const endpoint = payload?.id ? "admin/material/update" : "admin/material/create";
  return Http.post(endpoint, payload, options);
};
